import React from "react"
import {Dialog, Button} from "react-weui"
import PropTypes from "prop-types"

import './NotAvailableModal.less'

export default class NotAvailableModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      
    }
  }

  render() {
    const { onClose } = this.props
    return  (
      <React.Fragment>
        <Dialog
          id="NotAvailableModal"
          type="ios"
          show 
          style={{
            maxWidth: window.matchMedia("(min-width: 735px)").matches ? "360px" : "90%",
            width: window.matchMedia("(min-width: 735px)").matches ? "360px" : "90%",
            maxHeight: "95%",
            padding: "0.5vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <section>
            <p>这项服务只在欧洲一些城市提供，为此我们深表歉意。</p>
            <Button
              className={`advanceButton`}
              onClick={() => onClose()}
            >
              <p className="buttonText">关闭</p>
            </Button>
          </section>
        </Dialog>
      </React.Fragment>
      
    )
  }
}

NotAvailableModal.propTypes = {
  menu: PropTypes.object.isRequired, 
  onClose: PropTypes.func, 
}


// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/NotAvailableModal.jsx